export const messages = {
  en: {
    task: {
      search: {
        title: 'Search Condition',
        taskName: 'taskName',
        templateId: 'templateId',
        taskCron: 'taskCron',
        state: 'state',
        createTime: 'createTime',
        placeholder: 'Please enter task name'
      },
      list: {
        title: 'task List'
      },
      dialog: {
        addTitle: 'Add Task',
        editTitle: 'Edit Task',
        delTitle: 'Delete Task',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        taskId: 'taskId',
        taskName: 'taskName',
        templateId: 'templateId',
        taskCron: 'taskCron',
        state: 'state',
        createTime: 'createTime',
      },
      table: {
        taskId: 'taskId',
        taskName: 'taskName',
        templateId: 'templateId',
        taskCron: 'taskCron',
        state: 'state',
        createTime: 'createTime',
      },
      validate: {
        taskId: 'Please enter taskId',
        taskName: 'Please enter taskName',
        templateId: 'Please enter templateId',
        taskCron: 'Please enter taskCron',
        state: 'Please enter state',
        createTime: 'Please enter createTime',
      },
      add: {
        success: 'Add Task success'
      },
      edit: {
        success: 'Edit Task success'
      },
      delete: {
        success: 'Delete Task success',
        confirm: 'Are you sure to delete this task?'
      },
      fetchError: 'Failed to fetch task list',
      start: 'start',
      stop: 'stop'
    }
  },
  zh: {
    task: {
      search: {
        title: '查询条件',
        taskName: '任务名称',
        templateId: '模版名称',
        taskCron: '运行时间',
        state: '启停状态',
        createTime: '创建时间',
        placeholder: '请输入定时任务名称'
      },
      list: {
        title: '定时任务'
      },
      dialog: {
        addTitle: '添加定时任务',
        editTitle: '编辑定时任务',
        delTitle: '删除定时任务',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        taskId: '任务ID',
        taskName: '任务名称',
        templateId: '模版名称',
        taskCron: '运行时间',
        state: '启停状态',
        createTime: '创建时间',
      },
      table: {
        taskId: '任务ID',
        taskName: '任务名称',
        templateId: '模版名称',
        taskCron: '运行时间',
        state: '启停状态',
        createTime: '创建时间',
      },
      validate: {
        taskId: '请输入任务ID',
        taskName: '请输入任务名称',
        templateId: '请输入模版名称',
        taskCron: '请输入运行时间',
        state: '请输入启停状态',
        createTime: '请输入创建时间',
      },
      add: {
        success: '添加定时任务成功'
      },
      edit: {
        success: '编辑定时任务成功'
      },
      delete: {
        success: '删除定时任务成功',
        confirm: '确认删除该定时任务吗？'
      },
      fetchError: '获取定时任务列表失败',
      start: '启动',
      stop: '停止'
    }
  },
  'zh-TW': {
    task: {
      search: {
        title: '查詢條件',
        taskName: '任務名稱',
        templateId: '範本名稱',
        taskCron: '運行時間',
        state: '啟停狀態',
        createTime: '創建時間',
        placeholder: '請輸入定時任務名稱'
      },
      list: {
        title: '定時任務'
      },
      dialog: {
        addTitle: '添加定時任務',
        editTitle: '編輯定時任務',
        delTitle: '刪除定時任務',
        cancel: '取消',
        confirm: '確定'
      },
      form: {
        taskId: '任務ID',
        taskName: '任務名稱',
        templateId: '範本名稱',
        taskCron: '運行時間',
        state: '啟停狀態',
        createTime: '創建時間',
      },
      table: {
        taskId: '任務ID',
        taskName: '任務名稱',
        templateId: '範本名稱',
        taskCron: '運行時間',
        state: '啟停狀態',
        createTime: '創建時間',
      },
      validate: {
        taskId: '請輸入任務ID',
        taskName: '請輸入任務名稱',
        templateId: '請輸入範本名稱',
        taskCron: '請輸入運行時間',
        state: '請輸入啟停狀態',
        createTime: '請輸入創建時間',
      },
      add: {
        success: '添加定時任務成功'
      },
      edit: {
        success: '編輯定時任務成功'
      },
      delete: {
        success: '刪除定時任務成功',
        confirm: '確認刪除該定時任務嗎？'
      },
      fetchError: '獲取定時任務列表失敗',
      start: '啟動',
      stop: '停止'
    }
  }
}